import React, { createRef, useEffect, useState } from "react";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../../api/apiUtil";
import Table from "../../../components/Table/Table";
import getToken from "../../getToken";
import api from "../../../api/api";
import "./reserveReport.css";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from 'xlsx';
import excelIcon from "../../../images/icons/download.png";

const ReserveReport = () => {
  const refReserveTable = createRef();
  const [keyword, setKeyword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [reserveList, setReserveList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  let branchId = "8cd5fe32-a30a-11ed-b26e-6045bdd63acb";
  const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    branchId: branchId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });
  const mapDataRows = (data, value) => {
    return data && data.length > 0
      ? data.map((row, index) => ({
        ...row,
        tableNum: (value.currentPage - 1) * value.rowLimit + index + 1,
        id: `${row.id}-${index}` // override to ensure uniqueness
      }))
      : [];
  };
  const retrieveReserveList = async (value = paramReport) => {
    value.keyword = keyword || "";
    value.startDate = format(startDate, "yyyy-MM-dd");
    value.endDate = format(endDate, "yyyy-MM-dd");

    console.log(value);

    api.post("Admin/GetReservationHistoryReport", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          const data = response.data.data;
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setReserveList({
              isLoading: false,
              limit: data.rowLimit,
              data: mapDataRows(data.data, value),
              total: data.totalRecords,
              page: data.paging,
            });
            console.log(data.data);
          } else {
            setReserveList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  useEffect(() => {
    retrieveReserveList();
  }, [paramReport, startDate, endDate]);
  console.log(reserveList);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveReserveList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const fetchAllData = async () => {
    const allData = [];
    let currentPage = 1;

    try {
      while (true) {
        const response = await api.post(
          "Admin/GetReservationHistoryReport",
          { ...paramReport, currentPage },
          getToken()
        );
        const { data } = response.data.data.data;
        if (response.data && data && data.length > 0) {
          allData.push(...data);
          currentPage++;
        } else {
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    console.log("Fetched all data:", allData);
    return allData;
  };

  const exportToExcel = async () => {
    try {
      const allData = await fetchAllData();

      console.log("All Data:", allData);

      if (allData.length === 0) {
        console.warn("No data to export");
        return;
      }

      const excelDataFormatted = allData.map((row, index) => ({
        No: index + 1,
        Name: row.name || "Unknown",
        PhoneNo: row.phoneNo || "-",
        RoomName: row.roomName || "-",
        StartDate: row.startDate ? apiUtil.getDateShortMonthFormat(row.startDate) : "-",
        EndDate: row.endDate ? apiUtil.getDateShortMonthFormat(row.startDate) : "-",
        Adult: row.adult,
        Child: row.child,
        ExtraBedPrice: row.extraBedPrice,
      }));

      console.log("Excel Data Formatted:", excelDataFormatted);

      const fileName = "ReserveReport.xlsx";

      const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
      console.log("Worksheet:", ws);
      ws['!cols'] = [
        { wpx: 30 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ];
      ws['!cols'].forEach(col => {
        col.s = { alignment: { horizontal: 'left' } };
      });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ReserveReport");
      console.log("Workbook:", wb);

      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);

    }
  };

  return (
    <>
      <div className="Actions space_between">
        <h6 className="title_text mt-2">Reserve List History</h6>

        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* Export to Excel */}
          <div>
            <button onClick={exportToExcel} className="export-button">
              <img src={excelIcon} alt="excelIcon" className="icon" /> Export to Excel
            </button>

          </div>
          {/* dateRangePicker */}
          <div className="date-input-container ">
            <input
              type="text"
              className="inputBox input-right-side_text "
              value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                dateRange.endDate,
                "yyyy MMM dd"
              )}`}
              readOnly
              onClick={handleInputClick}
            />
            <img src={calenderIcon} className="iconDate" alt="calenderIcon" onClick={handleInputClick} />
            {showDatePicker && (
              <div className="input-dateRange">
                <DateRange
                  showDateDisplay={false}
                  ranges={[{ startDate, endDate, key: "selection" }]}
                  onChange={handleDateRangeChange}
                />
              </div>
            )}
          </div>
          <div>
            <CustomSearchBar value={keyword} setValue={setKeyword} onSearch={() => retrieveReserveList()} />
          </div>

        </div>
      </div>

      <div className="table_container report_table">
        <Table
          ref={refReserveTable}
          maxBodyHeight={reserveList.limit * 80}
          isLoading={reserveList.isLoading}
          grouping={reserveList.grouping}
          limit={reserveList.limit}
          page={reserveList.page}
          total={reserveList.total}
          data={reserveList.data}
          onPageChange={(page) => {
            setParamReport({
              ...paramReport,
              currentPage: page,
            });
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                return row.tableNum;
              },
              width: "80px",
              align: "center",
            },

            {
              title: "Name",
              render: (row) => {
                if (row.name == null || row.name == "") {
                  return "Unknown";
                }
                return row.name;
              },
              width: "80px",
            },
            {
              title: "PhoneNo",
              render: (row) => {
                return row.phoneNo ? row.phoneNo : '-';
              },
              width: "80px",
            },
            {
              title: "Email",
              render: (row) => {
                return row.email ? row.email : '-';
              },
              width: "80px",
            },
            {
              title: "RoomName",
              render: (row) => {
                return row.roomName ? row.roomName : '-';
              },
              width: "80px",
            },
            {
              title: "Start Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.startDate);
              },
              width: "120px",
            },
            {
              title: "End Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.endDate);
              },
              width: "120px",
            },
            {
              title: "Adult",
              render: (row) => {
                return row.adult ? row.adult : '0';
              },
              width: "80px",
            },
            {
              title: "Child",
              render: (row) => {
                return row.child ? row.child : '0';
              },
              width: "80px",
            },
            // {
            //   title: "Infants",
            //   render: (row) => {
            //     return row.infants ? row.infants : '0';
            //   },
            //   width: "80px",
            // },
            {
              title: "Extra Bed Price",
              render: (row) => {
                return row.extraBedPrice ? row.extraBedPrice : '0';
              },
              width: "150px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default ReserveReport;
